<!-- <div class="health-package-preview-wrapper">
  <p class="home-section-subtitle">
    <span class="title-label">
      {{'Health_packages' | translate}} 
    </span>
    <span class="see-all"
      (click)="openPackages()">
      {{'See_all' | translate}}
      <img class="title-icon" src="assets/icons/slot/right_arrow.svg" alt="arrow">
    </span>
  </p>
  <div class="cards">
    <div class="card-layout" *ngFor="let c of packs.concepts">
      <div class="card row cursor-pointer" (click)="openPackages(c)">
        <div class="image">
          <ng-container  *ngIf="c.detail | translate : 'LANGARRAY' : 'imageURL'; else DFLTIMG">
            <img class="type-image" [src]="c.detail | translate : 'LANGARRAY' : 'imageURL'" alt="">
          </ng-container>
          <ng-template #DFLTIMG>
            <img class="type-image" src="assets/icons/health-package/healthpack_dflt.png" alt="">
          </ng-template>
        </div>
        <div class="card-content font-default-subtitle">
          <div>
            <p class="health-package-title">{{c.name |  translate : 'LANGARRAY' : 'name'}}</p>
          </div>
          <div class="font-primary-subtitle bold clmn">
            <span *ngIf="getDiscountChargeByFacility(c)">{{getDiscountChargeByFacility(c)}} {{currency_code}} </span>
            <span *ngIf="getChargeByFacility(c)" [ngClass]="{ 'lstrike' : getDiscountChargeByFacility(c) }">{{getChargeByFacility(c)}}
              {{currency_code}} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="home-wrapper">
  <div class="services-wrapper" *ngIf="onDemandAttributes?.wellNessPackageClassification.length > 0">
      <p class="home-section-subtitle">
          <span class="title-label">
            {{'Wellness_packages' | translate}} 
          </span>
          <span class="see-all"
            (click)="pkgSeeAll('SEEALLHEALTHPACKAGES', {classification: 'WELLNESS'})">
            {{'See_all' | translate}}
            <img class="title-icon" src="assets/icons/slot/right_arrow.svg" alt="arrow">
          </span>
      </p>
      <div class="service-list-wrapper">
      <div class="service-list" >
        <div class="service-list-item" *ngFor="let item of onDemandAttributes?.wellNessPackageClassification" (click)="openPackages('WELLNESS',item)" [style.background]="item?.bgColor || null">
          <div class="service-icon">
            <img *ngIf="item?.image" [src]="item?.image">
          </div>
          <div class="service-context">
            <p class="service-label">
              {{item['label'] | translate}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="services-wrapper" *ngIf="onDemandAttributes?.promoPackageClassification.length > 0">
      <p class="home-section-subtitle">
          <span class="title-label">
            {{'Promo_packages' | translate}} 
          </span>
          <span class="see-all"
            (click)="pkgSeeAll('SEEALLHEALTHPACKAGES', {classification: 'PROMO'})">
            {{'See_all' | translate}}
            <img class="title-icon" src="assets/icons/slot/right_arrow.svg" alt="arrow">
          </span>
      </p>
      <div class="service-list-wrapper">
      <div class="service-list" >
        <div class="service-list-item promo-item" *ngFor="let item of onDemandAttributes?.promoPackageClassification" (click)="openPackages('PROMO',item)">
          <div class="promo-service-icon" [style.background]="item?.bgColor || 'linear-gradient(to bottom,#0B9991 35%, #245BA4)'">
           <img *ngIf="item?.image" [src]="item?.image">
          </div>
          <div class="service-context">
            <p class="promo-service-label">
              {{item['label'] | translate}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>